<template>
	<div class="admin-ticket-filters">
		<div class="vx-row">
			<div
				class="admin-ticket-filters__item admin-ticket-filters__date vx-col mt-3"
			>
				<div class="vs-con-input"></div>
				<vs-datepicker
					v-model="off"
					@change="filter"
					format="dd.MM.yyyy"
					:placeholder="$t('from')"
					name="date"
					class="w-full xl:w-auto datepicker"
				></vs-datepicker>
			</div>
			<div
				class="admin-ticket-filters__item admin-ticket-filters__date vx-col mt-3"
			>
				<div class="vs-con-input"></div>
				<vs-datepicker
					v-model="to"
					@change="filter"
					format="dd.MM.yyyy"
					:placeholder="$t('to')"
					name="date"
					class="w-full xl:w-auto datepicker"
				></vs-datepicker>
			</div>
			<div class="admin-ticket-filters__item vx-col mt-3">
				<vs-custom-button
					color="dark"
					type="border"
					@click="reset"
					class="vs-custom-button w-full pl-1 pr-1 w-full"
				>{{ $t('reset') }}</vs-custom-button>
			</div>
			<div
				class="admin-ticket-filters__item vx-col mt-3"
			>
				<v-select
					v-model="manager"
					:reduce="item => item.id"
					:options="managers"
					:dir="$vs.rtl ? 'rtl' : 'ltr'"
					:placeholder="$t('manager')"
					@input="filter"
					label="full_name"
					class="single-row-select w-full"
				/>
			</div>
			<div
				class="admin-ticket-filters__item vx-col mt-3"
			>
				<v-select
					v-model="author"
					:reduce="item => item.id"
					:options="authors"
					:dir="$vs.rtl ? 'rtl' : 'ltr'"
					:placeholder="$t('author')"
					@input="filter"
					label="full_name"
					class="single-row-select w-full"
				/>
			</div>
			<div
				class="admin-ticket-filters__item vx-col mt-3"
			>
				<v-select
					v-model="website"
					:reduce="item => item.id"
					:options="websites"
					:dir="$vs.rtl ? 'rtl' : 'ltr'"
					:placeholder="$t('site')"
					@input="filter"
					label="name"
					class="single-row-select w-full"
				/>
			</div>
			<div
				class="admin-ticket-filters__item vx-col mt-3"
			>
				<v-select
					v-model="work"
					:reduce="item => item.id"
					:options="works"
					:dir="$vs.rtl ? 'rtl' : 'ltr'"
					:placeholder="$t('workType')"
					@input="filter"
					label="name"
					class="single-row-select w-full"
				/>
			</div>
			<div
				class="admin-ticket-filters__item vx-col mt-3"
			>
				<v-select
					v-model="level"
					:reduce="item => item.id"
					:options="levels"
					dir="$vs.rtl ? 'rtl' : 'ltr'"
					:placeholder="$t('qualityLevel')"
					@input="filter"
					label="name"
					class="single-row-select w-full"
				/>
			</div>
			<div class="admin-ticket-filters__item search vx-col flex items-center mt-3">
				<vs-input
					v-model="name"
					@input="filter"
					icon="search"
					icon-after
					:placeholder="$t('searchByNameAndClient')"
					class="w-full"
				/>
			</div>
			<div class="admin-ticket-filters__item search vx-col flex items-center mt-3">
				<vs-input
					v-model="cid"
					:placeholder="$t('searchByCid')"
					icon="search"
					@input="filter"
					icon-after
					class="w-full"
				/>
			</div>
			<div class="admin-ticket-filters__item search vx-col flex items-center mt-3">
				<vs-input
					v-model="phone"
					:placeholder="$t('searchByPhone')"
					icon="search"
					icon-after
					@input="filter"
					class="w-full"
				/>
			</div>
			<div class="admin-ticket-filters__item search vx-col flex items-center mt-3">
				<v-select
					v-model="orderType"
					:reduce="item => item.id"
					:options="orderTypeOptions"
					placeholder="Order type"
					label="label"
					:clearable="true"
					class="single-row-select w-full"
					@input="filter"
				/>
			</div>

			<div class="admin-ticket-filters__item vx-col flex items-center mt-3">
<!--				<div>{{ $t('totalWorks') }}-->
<!--					<span>: {{ total }}</span>-->
<!--				</div>-->
			</div>

		</div>
	</div>
</template>

<script>
import vSelect from "vue-select";
import databaseManager from '../../mixins/databaseManager';

export default {
	name: "AdminFilters",
	mixins: [databaseManager],
	components: {
		vSelect
	},
	props: {
		works: {
			type: Array,
			required: true
		},
		levels: {
			type: Array,
			required: true
		},
		selectedManager: {
			required: true,
		},
		selectedAuthor: {
			required: true,
		},
		selectedClient: {
			required: true,
		},
		selectedWebsite: {
			required: true,
		},
		selectedLevel: {
			required: true,
		},
		selectedWork: {
			required: true,
		},
		selectedOrderType: {
			required: true,
		},
		selectedOff: {
			required: true,
		},
		selectedTo: {
			required: true,
		},
		selectedName: {
			required: true,
			type: String,
		},
		selectedCid: {
			required: true,
			type: String,
		},
		selectedPhone: {
			required: true,
		}
	},
	data() {
		return {
			managers: [],
			authors: [],
			clients: [],
			websites: [],
			orderTypeOptions: [
				{ id: 1, label: 'PPG Orders' },
				{ id: 0, label: 'Basic orders' },
			]
		};
	},
	computed: {
		manager: {
			get() 		{ return this.selectedManager; },
			set(value) 	{ this.$emit('update:selectedManager', value); }
		},
		author: {
			get() 		{ return this.selectedAuthor; },
			set(value) 	{ this.$emit('update:selectedAuthor', value); }
		},
		client: {
			get() 		{ return this.selectedClient; },
			set(value) 	{ this.$emit('update:selectedClient', value); }
		},
		website: {
			get() 		{ return this.selectedWebsite; },
			set(value) 	{ this.$emit('update:selectedWebsite', value); }
		},
		level: {
			get() 		{ return this.selectedLevel; },
			set(value) 	{ this.$emit('update:selectedLevel', value); }
		},
		work: {
			get() 		{ return this.selectedWork; },
			set(value) 	{ this.$emit('update:selectedWork', value); }
		},
		off: {
			get() 		{ return this.selectedOff; },
			set(value) 	{ this.$emit('update:selectedOff', value); }
		},
		to: {
			get() 		{ return this.selectedTo; },
			set(value) 	{ this.$emit('update:selectedTo', value); }
		},
		name: {
			get() 		{ return this.selectedName; },
			set(value) 	{ this.$emit('update:selectedName', value); }
		},
		cid: {
			get() 		{ return this.selectedCid; },
			set(value) 	{ this.$emit('update:selectedCid', value); }
		},
		phone: {
			get() 		{ return this.selectedPhone; },
			set(value) 	{ this.$emit('update:selectedPhone', value); }
		},
		orderType: {
			get() 		{ return this.selectedOrderType; },
			set(value) 	{ this.$emit('update:selectedOrderType', value); }
		}
	},
	methods: {
		addFullName(item) {
			let output = [];
			const firstName = item.first_name;
			const lastName = item.last_name;

			if(firstName) output.push(firstName);
			if(lastName) output.push(lastName);

			item.full_name = output.join(" ") || `#${item.id}`;

			return item;
		},
		reset() {
			this.selectedManager = null;
			this.selectedAuthor = null;
			this.selectedClient = null;
			this.selectedWebsite = null;
			this.selectedWork = null;
			this.selectedLevel = null;
			this.selectedOrderType = null;
			this.off = "";
			this.to = "";
			this.name = "";
			this.cid = "";
			this.phone = "";
		},
		filter() {
			this.$nextTick(() => {
				// let options = {
				// 	manager: this.selectedManager,
				// 	author: this.selectedAuthor,
				// 	client: this.selectedClient,
				// 	name: this.name,
				// 	work: this.selectedWork,
				// 	level: this.selectedLevel,
				// 	off: this.off,
				// 	to: this.to,
				// };

				this.$emit("search");
			})
		},
	},
	async mounted() {
    const requests = [
        async () => {
          this.managers = (await this.dbGetMangers()).map(this.addFullName);
        },
        async () => {
          this.authors = (await this.dbGetAuthors()).map(this.addFullName);
        },
        async () => {
          this.clients = (await this.dbGetClients()).map(this.addFullName);
        },
        async () => {
          this.websites = (await this.dbGetWebsites());
        },
    ]
    await Promise.all(requests.map(item => item()))
	},
};
</script>

<style lang="scss">
@import "../../assets/scss/vuexy/variables.scss";

.admin-ticket-filters {
	&__item {
		width: 11.111%;

		@media screen and (max-width: 1920px) {
			width: 33.333%;
		}

		@media screen and (max-width: 578px) {
			width: 50%;
		}
	}

	&__date {
		@media screen and (max-width: 578px) {
			width: 100%;
		}
	}

	.search {
		.vs-input {
			overflow: hidden;
		}

		.vs-icon {
			height: 100%;
			width: 35px;
			background: $primary;
			position: absolute;
			top: 0;
			right: 0;
			color: white !important;
			display: flex;
			align-items: center;
			justify-content: center;
			border-top-right-radius: 4px;
			border-bottom-right-radius: 4px;
			font-size: 22px;
		}

		@media screen and (max-width: 578px) {
			width: 100%;
			order: -1;
		}
	}

	.vs__dropdown {
		&-menu {
			position: absolute !important;
			max-height: 160px !important;
			// min-width: 230px !important;
			z-index: 100000;

			@media screen and (max-width: 1600px) {
				min-width: 100% !important;
			}
		}

		&-option {
			position: relative !important;
			// width: 100%;
			text-overflow: ellipsis;
			overflow-x: hidden;
		}
	}
}
</style>
